import React from "react";
import styles from "./style.module.scss";
import { UIText } from "src/components/uIKit";
import { ServiceIncludesList } from "src/utils/types";
import { LOGIN_STEP, ROUTES, TEXT_TAGS, URL_SOURCE_TYPE } from "src/utils/enums";
import { PcPlusCardItem, Separator } from "..";
import { useAppSelector } from "src/hooks/useRedux";
interface PcPlusContentProps {
  headerText?: string;
  title?: string;
  subTitle?: string;
  image?: string;
  body?: ServiceIncludesList[];
  footerTitle?: string;
  footerOptions?: string[];
}

const PcPlusContent = ({
  headerText,
  title,
  subTitle,
  image,
  body,
  footerTitle,
  footerOptions,
}: PcPlusContentProps) => {
  const { strings } = useAppSelector((state) => state.app);
  const currentSource = window.location.pathname.split("/")[1].toLowerCase(); // ensure, sms,campaign,rep_manual ect

  const isEnsureOrPfsRep =
    currentSource === URL_SOURCE_TYPE.ENSURE ||
    currentSource === URL_SOURCE_TYPE.PFS_REP;

  const isSmsOrCampaignOrMarketingOrSmsShareOrApp =
    currentSource === URL_SOURCE_TYPE.SMS ||
    currentSource === URL_SOURCE_TYPE.CAMPAIGN ||
    currentSource === URL_SOURCE_TYPE.MARKETING ||
    currentSource === URL_SOURCE_TYPE.SMS_SHARE ||
    currentSource === URL_SOURCE_TYPE.APP;

  return (
    <div className={styles.representativeWrapper}>
      {!isEnsureOrPfsRep && !isSmsOrCampaignOrMarketingOrSmsShareOrApp && (
        <a
          id="link-back"
          href={`/${currentSource}${LOGIN_STEP.LOGIN}`}
          className={styles.backButton}
          aria-describedby={"aria-label-text"}
        >
          <UIText
            isAriaHidden={isEnsureOrPfsRep}
            text={strings.t_back}
            size={18}
            weight={400}
            style={styles.link}
          />
        </a>
      )}

      {headerText && (
        <UIText
          text={headerText}
          tag={TEXT_TAGS.H1}
          size={24}
          weight={500}
          style={styles.headerText}
        />
      )}
      <Separator className={styles.separator} />

      <UIText
        text={title}
        size={18}
        weight={500}
        style={styles.representativeTitle}
      />
      <UIText
        text={subTitle}
        size={16}
        weight={400}
        style={styles.representativeSubTitle}
      />

      {body &&
        body.map((item, index) => (
          <PcPlusCardItem
            key={index}
            image={item.image}
            imageWidth={item.imageWidth}
            imageHeight={item.imageHeight}
            title={item.title}
            subTitle={item.subTitle}
            options={item.options || []}
          />
        ))}
      <br />
      <UIText
        text={footerTitle || ""}
        size={18}
        weight={500}
        style={styles.footerTitle}
      />

      {footerOptions && (
        <ul>
          {footerOptions.map((option, index) => (
            <li key={index} className={styles.footerOptionListItem}>
              <UIText
                text={option}
                size={16}
                weight={400}
                style={styles.footerOption}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PcPlusContent;
